import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateOrgStructureItem as apiUpdate } from "../../api/apiOrgStructureItems";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateOrgStructureItem() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();
    const { mutate: editOrgStructureItem, isPending: isUpdate, error } = useMutation({
        mutationFn: ({ req, id }) => apiUpdate(req, id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); queryClient.invalidateQueries({ queryKey: ["orgStructureItems"] }); navigate('/org-structure-items'); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { editOrgStructureItem, isUpdate, error };
}
